import React, { useState, useEffect, useRef } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints';
import { getApiOptions, setApiOptions, getSelectedFilters } from "../../ui/multiselectApiOptionsReducer"
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { selectQueryParams } from '../../ui/customerListingReducer';

const MultiSelectField = (props) => {
  const queryParams = useSelector(selectQueryParams);
  const apiName = props.dynamicOptions?.apiName;
  const defaultFilters = props.dynamicOptions?.defaultFilters || {};
  const optionsSelection = useRef();
  const [options, setOptions] = useState([]);
  const { labelAttr, valueAttr, displayValueAttr } = props;
  const [dynamicApi] = getApi(apiName);
  const fetchedOptions = useSelector(getApiOptions);
  const fetchSelectedFilters = useSelector(getSelectedFilters);
  const [filtersLength, setFilterLength] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    if (apiName && fetchedOptions[apiName]) {
      if((props.dynamicOptions?.dependsOnFields || []).length !== 0){
        optionsSelection.current.resetSelectedValues();
        setOptions([]);
        let apiOptions = [];
        let params = {filters: {}, fields: 'options'};
        dispatch(setApiOptions({ apiName, apiOptions, params }));
      } else{
        setOptions(fetchedOptions[apiName]);
      }
    } else if (props.options && props.options.length > 0) {
      setOptions(props.options);
    } else if((props.dynamicOptions?.dependsOnFields || []).length === 0) {
      fetchDynamicOptions()
    }
  }, []);

  useEffect(() => {
    if ((props.dynamicOptions?.dependsOnFields || []).length !== 0) {
      const params = props.dynamicOptions.dependsOnFields.reduce((obj, fieldName) => {
        if (props?.stateModel && props?.stateModel[fieldName]) {
          obj[fieldName] = props.stateModel[fieldName];
        }
        return obj;
      }, {});
      if (Object.keys(params).length > 0) {
        fetchDynamicOptions()
      }
    }
  }, (props.dynamicOptions?.dependsOnFields || []).map((fieldName) => props?.stateModel ? props?.stateModel[fieldName] : ""))

  useEffect(() => {
    optionsSelection.current.resetSelectedValues();
  }, [props.reset]);

  const fetchDynamicOptions = async () => {
    try {
      let isDependentFieldEmpty = false;
      let filters = {};
      const params = {};
      (props.dynamicOptions?.dependsOnFields || []).forEach((fieldName) => {
        if(props.stateModel[fieldName].length === 0){
          isDependentFieldEmpty = true;
        } else{
          isDependentFieldEmpty = false;
          filters[fieldName] = props.stateModel[fieldName];
          params['filters'] = filters
        }
      })
      if(isDependentFieldEmpty){
        optionsSelection.current.resetSelectedValues();
        setOptions([]);
      } else {
        params.fields = 'options';
        if(!params.filters){
          params['filters'] = defaultFilters;
        }
        setFilterLength(Object.values(params.filters).flatMap((item) => item).length);
        if(filtersLength === 0 &&
          filtersLength !== Object.values(params.filters).flatMap((item) => item).length &&
          (Object.values(fetchSelectedFilters || {})[0] === Object.values(params.filters)[0])){
          setOptions(fetchedOptions[apiName])
        } else {
          const response = await dynamicApi(params).unwrap();
          const { dataAttr } = props.dynamicOptions;
          const apiOptions = response.data[dataAttr].map((dataItem) => {
            return {
              [labelAttr]: dataItem[labelAttr],
              [valueAttr]: dataItem[valueAttr],
              'displayValueAttr': `${dataItem[displayValueAttr]} - ${dataItem[labelAttr]}`
            }
          })
          setOptions(apiOptions);
          optionsSelection.current.resetSelectedValues();
          dispatch(setApiOptions({ apiName, apiOptions, params }));
        }
      }
    } catch (error) {
      toast.error('Something went wrong!')
    }
  }

  const selectedValues = () => {
    if (props.stateModel !== undefined){
      return options.filter((option) => {
        if(queryParams.filters){
          return (queryParams.filters[props.fieldName] || []).indexOf(option[valueAttr]) !== -1;
        }
        let checkVal = (props.stateModel[props.fieldName] &&
          props.stateModel[props.fieldName].constructor) === Array ?
          props.stateModel[props.fieldName] :
          [props.stateModel[props.fieldName]];
        return (checkVal || []).indexOf(option[valueAttr]) !== -1;
      });
    }
  }

  return <Multiselect
    id={props.id}
    options={options}
    selectedValues={selectedValues()}
    selectionLimit={props.selectionLimit}
    onSelect={props.onSelect}
    onRemove={props.onRemove}
    displayValue={props.displayValue ? props.displayValue : 'displayValueAttr'}
    ref={optionsSelection}
    closeOnSelect={props.closeOnSelect}
    disable={props.disable}
    reset={true}
    showArrow={true}
    customArrow={true}
    avoidHighlightFirstOption={true}
    placeholder={props.placeholder}
    singleSelect={props.singleSelect}
  />
}

export default MultiSelectField;
